import { render } from "./OnlineStocks.vue?vue&type=template&id=1d390def"
import script from "./OnlineStocks.vue?vue&type=script&lang=js"
export * from "./OnlineStocks.vue?vue&type=script&lang=js"

import "./OnlineStocks.vue?vue&type=style&index=0&id=1d390def&lang=css"

import exportComponent from "C:\\Users\\oozdemir\\Documents\\GitHub\\bootstrap-sample\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__